import type { $Fetch } from 'ofetch';
import type { Tentativa } from '@/domain/model/Tentativa';
import type { TentativaGateway } from '@/application/port/out/TentativaGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/tentativas';

export class HttpTentativaGateway implements TentativaGateway {
  constructor(private readonly client: $Fetch) {}

  async list(avaliacaoId: string, matriculaId: string): Promise<Tentativa[]> {
    const res = await this.client<ApiResponse<Tentativa[]>>(PATH, {
      method: 'GET',
      params: { avaliacaoId, matriculaId },
    });
    assertApiSuccess(res);
    return res.data;
  }

  async get(id: string): Promise<Tentativa> {
    const res = await this.client<ApiResponse<Tentativa>>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
